// extracted by mini-css-extract-plugin
export var actionButton = "_l7-t";
export var buttonContainer = "_l7-0";
export var buttonContainer2 = "_l7-1";
export var buttonSection = "_l7-2";
export var details = "_l7-3";
export var dropdownItem = "_l7-5";
export var dropdownItemsContainer = "_l7-4";
export var fileInput = "_l7-r";
export var headerButton = "_l7-6";
export var icon = "_l7-7";
export var input = "_l7-8";
export var macroListItem = "_l7-9";
export var mainContent = "_l7-a";
export var microText = "_l7-b";
export var modal = "_l7-w";
export var optionsButton = "_l7-c";
export var paperclip = "_l7-s";
export var pillContent = "_l7-d";
export var preview = "_l7-e";
export var preview2 = "_l7-f";
export var quillEditor = "_l7-q";
export var selectedMacro = "_l7-g";
export var sidebar = "_l7-h";
export var sidebarHeader = "_l7-j";
export var sidebarList = "_l7-i";
export var sidebarListItem = "_l7-k";
export var sidebarSearch = "_l7-l";
export var snoozeDurationWrapper = "_l7-v";
export var statusPillContainer = "_l7-m";
export var tagsContainer = "_l7-n";
export var unselectedMacro = "_l7-o";
export var variable = "_l7-u";
export var wrapper = "_l7-p";